import styled, { css } from 'vue-styled-components';

import {
    FLEX_VERTICAL_CENTER_DIV,
    FLEX_COLUMN_DIV,
} from '@styles/common.styled.component';
import { COLORS } from '@styles/common.styled';

import { isValueExist } from '@/utils/utils';

export default {
    name: 'InputField',
    props: {
        unit: {
            type: String,
            default: '',
        },
        value: {
            type: Number | String,
            default: 0,
        },
        type: {
            type: String,
            default: 'number',
        },
        cleaner: {
            type: Function,
            default: R.identity,
        },
        errorText: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        autocomplete: {
            type: String,
            default: 'off',
        },
        errorDirection: {
            type: String,
            default: 'left',
        },
        id: String,
        maxLength: Number,
        placeholder: String,
    },
    methods: {
        onChange(e) {
            const isPaste = isValueExist(e.clipboardData);

            const v = isPaste
                ? e.clipboardData.getData('text')
                : e.target.value;

            this.onInput(v);
        },
        onInput(v) {
            const cleaned = this.cleaner(v);

            this.$emit('input', cleaned);
            if (v !== cleaned) {
                this.$forceUpdate();
            }
        },
    },
    render() {
        const {
            type,
            value,
            unit,
            $refs,
            errorText,
            disabled,
            autocomplete,
            errorDirection,
            onChange,
            id,
            maxLength,
            placeholder,
        } = this;

        return (
            <Wrapper>
                <InputWrapper
                    class="input-field"
                    onClick={() => $refs.input && $refs.input.focus()}
                    disabled={disabled}
                >
                    <input
                        class="hide-input-arrow"
                        type={type}
                        value={value}
                        onInput={onChange}
                        onFocus={({ target = {} }) =>
                            this.$emit(
                                'focus',
                                R.equals(document.activeElement, target)
                            )
                        }
                        ref="input"
                        disabled={disabled}
                        autocomplete={autocomplete}
                        id={`id_${id}`}
                        {...(maxLength && { maxLength })}
                        {...(placeholder && { placeholder })}
                    />
                    {unit && <Unit>{unit}</Unit>}
                </InputWrapper>
                {errorText && (
                    <ErrorText errorDirection={errorDirection} domPropsInnerHTML={errorText} />
                )}
            </Wrapper>
        );
    },
};

const Wrapper = styled(FLEX_COLUMN_DIV)`
    align-items: flex-start;
    width: 100%;
`;

const InputWrapper = styled(FLEX_VERTICAL_CENTER_DIV, { disabled: Boolean })`
    justify-content: space-between;
    position: relative;
    height: 32px;
    border-radius: 2px;
    border: solid 1px ${COLORS['gray-25']};
    padding: 0 8px;

    input {
        margin-left: auto;
        border: none;
        text-align: right;
        max-width: 80%;

        &:hover,
        &:focus {
            outline: none;
        }
        ${({ disabled }) =>
            disabled &&
            css`
                cursor: not-allowed;
            `}
    }

    background: ${({ disabled }) => (disabled ? COLORS['gray-15'] : 'white')};
    ${({ disabled }) =>
        disabled &&
        css`
            cursor: not-allowed;
        `}
`;

const Unit = styled.span`
    font-size: 13px;
    font-weight: 500;
    color: ${COLORS['gray-40']};
    margin-left: 4px;
`;

const ErrorText = styled('span', { errorDirection: String })`
    display: block;
    font-size: 13px;
    color: ${COLORS['red-60']};
    margin-top: 4px;
    width: 100%;
    text-align: ${R.prop('errorDirection')};
    white-space: pre-line;
`;
